export default __webpack_public_path__ + "static/media/text-block-thumbnail-dark.3fe96237.svg";